import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var FieldOptionTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(FieldOptionTransformer, _BaseTransformer);
  var _super = _createSuper(FieldOptionTransformer);
  function FieldOptionTransformer() {
    _classCallCheck(this, FieldOptionTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(FieldOptionTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        active: data.active,
        label: data.label,
        color: data.color,
        value: data.id,
        id: data.id,
        special: data.value,
        account_name: data.account_name,
        record_id: data.record_id,
        contact_status: data.contact_status,
        contract_status: data.contract_status,
        billing_method: data.billing_method,
        hourly_rate_type: data.hourly_rate_type
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return FieldOptionTransformer;
}(BaseTransformer);